const PLUS_JAKARTA_SANS = "Plus Jakarta Sans";

const fonts = {
  PLUS_JAKARTA_SANS
};

export default fonts;
